_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[25],{

/***/ "89Ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ff2n");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("iuhU");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("TmFx");
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_5__);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Button = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_4__["memo"])( /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_4__["forwardRef"])(function (_ref, ref) {
  var _clsx;

  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'button' : _ref$as,
      icon = _ref.icon,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? 'left' : _ref$iconPosition,
      _ref$buttonStyle = _ref.buttonStyle,
      buttonStyle = _ref$buttonStyle === void 0 ? 'normal' : _ref$buttonStyle,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["as", "icon", "children", "className", "iconPosition", "buttonStyle"]);

  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsxs"])(As, _objectSpread(_objectSpread({
    className: Object(clsx__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.button, className, (_clsx = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_clsx, _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.buttonIconRight, iconPosition === 'right'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_clsx, _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.buttonDanger, buttonStyle === 'danger'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_clsx, _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.buttonDisabled, props.disabled), _clsx)) // @ts-ignore
    ,
    ref: ref
  }, props), {}, {
    children: [icon && /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])("span", {
      className: Object(clsx__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(icon, children && _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.icon)
    }), children]
  }));
}));
Button.displayName = 'Button';

/***/ }),

/***/ "Ff2n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _objectWithoutProperties; });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ "TmFx":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__58Y2e","buttonIconRight":"button_buttonIconRight__1aVop","icon":"button_icon__1D0K9","buttonDanger":"button_buttonDanger__n621T","buttonDisabled":"button_buttonDisabled__1L1QL"};

/***/ }),

/***/ "iuhU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ }),

/***/ "mb5R":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"ol":"termsOfUse_ol__3WxZI","li":"termsOfUse_li__kD9Qm","section":"termsOfUse_section__3czNj","heading":"termsOfUse_heading__1BPbt","buttons":"termsOfUse_buttons__28bZU","note":"termsOfUse_note__kU3GA"};

/***/ }),

/***/ "v/pb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ TermsOfUsePage; });

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./components/Layout.tsx + 4 modules
var Layout = __webpack_require__("apO0");

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__("89Ff");

// EXTERNAL MODULE: ./components/TermsOfUse/termsOfUse.module.scss
var termsOfUse_module = __webpack_require__("mb5R");
var termsOfUse_module_default = /*#__PURE__*/__webpack_require__.n(termsOfUse_module);

// CONCATENATED MODULE: ./components/TermsOfUse/TermsOfUse.tsx





var TermsOfUse_TermsOfUse = function TermsOfUse() {
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])("section", {
    className: termsOfUse_module_default.a.section,
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
      className: termsOfUse_module_default.a.buttons,
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
        href: "/",
        passHref: true,
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])(Button["a" /* Button */], {
          icon: "icon-arrow-left2",
          children: "Strona G\u0142\xF3wna"
        })
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("article", {
      className: termsOfUse_module_default.a.note,
      children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h2", {
        className: termsOfUse_module_default.a.heading,
        children: "Regulamin PolskiFrontend.pl"
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
        children: "Wersja z dnia 14. stycznia 2021r."
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
        className: termsOfUse_module_default.a.ol,
        children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
          className: termsOfUse_module_default.a.li,
          children: ["Postanowienia og\xF3lne", /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
            className: termsOfUse_module_default.a.ol,
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Niniejszy Regulamin (zwany dalej \u201ERegulaminem\u201D) okre\u015Bla zasady korzystania z serwisu PolskiFrontend.pl (zwanego dalej: \u201ESerwisem\u201D) dla u\u017Cytkownik\xF3w indywidualnych (zwanych dalej \u201EU\u017Cytkownikami\u201D)."
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Administratorem Serwisu jest Micha\u0142 Miszczyszyn prowadz\u0105cy dzia\u0142alno\u015B\u0107 gospodarcz\u0105 pod firm\u0105 \u201EType of Web - Micha\u0142 Miszczyszyn\u201D, zarejestrowan\u0105 w\xA0Centralnej Ewidencji i\xA0Informacji o\xA0Dzia\u0142alno\u015Bci Gospodarczej pod adresem ul. Ba\u017Cantowa 9/21, 80-175 Gda\u0144sk, NIP: 6040080451 (zwany dalej: \u201EUs\u0142ugodawc\u0105\u201D). Adres do korespondencji: ul. Ba\u017Cantowa 9/21, 80-175 Gda\u0144sk; adres e-mail: hi@typeofweb.com."
            })]
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
          className: termsOfUse_module_default.a.li,
          children: ["Zasady korzystania z\xA0Serwisu", /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
            className: termsOfUse_module_default.a.ol,
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Serwis s\u0142u\u017Cy do udost\u0119pniania pyta\u0144 rekrutacyjnych dodawanych przez U\u017Cytkownik\xF3w. Us\u0142ugodawca \u015Bwiadczy us\u0142ug\u0119 polegaj\u0105c\u0105 na udost\u0119pnianiu infrastruktury teleinformatycznej celem dodawania, przechowywania i\xA0udost\u0119pniania pyta\u0144 dodawanych przez U\u017Cytkownik\xF3w."
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Korzystanie z\xA0Serwisu jest bezp\u0142atne i\xA0nie wymaga logowania U\u017Cytkownika."
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Korzystanie z\xA0Serwisu wymaga przegl\u0105darki internetowej z\xA0w\u0142\u0105czon\u0105 obs\u0142ug\u0105 j\u0119zyka JavaScript. Us\u0142ugodawca zastrzega sobie prawo do wspierania tylko wybranych, najpopularniejszych przegl\u0105darek internetowych."
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Ka\u017Cde pytanie dodawane do Serwisu, przed opublikowaniem podlega weryfikacji przez Us\u0142ugodawc\u0119 i\xA0mo\u017Ce zosta\u0107 zmodyfikowane lub usuni\u0119te. Okres od dodania pytania, do jego opublikowania w\xA0Serwisie, mo\u017Ce trwa\u0107 kilka dni."
            }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
              children: ["Dodaj\u0105c tre\u015B\u0107 do Serwisu, U\u017Cytkownik:", /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
                className: termsOfUse_module_default.a.ol,
                children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "ma obowi\u0105zek przestrzegania zasad kultury osobistej i\xA0netykiety;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "ma obowi\u0105zek poprawnego formatowania tekstu z\xA0wykorzystaniem technologii Markdown w\xA0standardzie CommonMark, a\xA0tak\u017Ce do przestrzegania zasad ortografii i\xA0gramatyki j\u0119zyka polskiego;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "o\u015Bwiadcza, \u017Ce przys\u0142uguj\u0105 mu prawa do publikacji dodawanych tre\u015Bci i\xA0wyra\u017Ca zgod\u0119 na ich wykorzystanie przez Us\u0142ugodawc\u0119 w\xA0Serwisie, a\xA0tak\u017Ce poza nim, nie wy\u0142\u0105czaj\u0105c cel\xF3w komercyjnych;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "ponosi pe\u0142n\u0105 odpowiedzialno\u015B\u0107 zwi\u0105zan\u0105 z\xA0ewentualnym naruszeniem Regulaminu i przepis\xF3w prawa, a\xA0w tym d\xF3br osobistych, praw w\u0142asno\u015Bci intelektualnej, um\xF3w o\xA0zachowaniu poufno\u015Bci i\xA0innych;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "wyra\u017Ca zgod\u0119 na modyfikowanie, moderowanie oraz odmow\u0119 publikacji tre\u015Bci przez Us\u0142ugodawc\u0119, w\xA0celu utrzymania wysokiej jako\u015Bci tre\u015Bci publikowanych w Serwisie."
                })]
              })]
            }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
              children: ["U\u017Cytkownik nie mo\u017Ce:", /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
                className: termsOfUse_module_default.a.ol,
                children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "wykorzystywa\u0107 Serwisu, ani tre\u015Bci w\xA0nim zamieszczonych, do dzia\u0142alno\u015Bci komercyjnej. Pod poj\u0119ciem dzia\u0142alno\u015Bci komercyjnej rozumie si\u0119 jak\u0105kolwiek dzia\u0142alno\u015B\u0107 marketingow\u0105, promocyjn\u0105 lub wspomagaj\u0105c\u0105 te dzia\u0142ania, na przyk\u0142ad umieszczanie reklam w\xA0tre\u015Bciach dodawanych do Serwisu, lub dowolne inne sposoby czerpania korzy\u015Bci maj\u0105tkowej z\xA0Serwisu;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "dodawa\u0107 do Serwisu tre\u015Bci o\xA0charakterze erotycznym, zawieraj\u0105cych wulgaryzmy lub z\xA0innych wzgl\u0119d\xF3w nieodpowiednich dla os\xF3b poni\u017Cej 18. roku \u017Cycia;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "dodawa\u0107 do Serwisu tre\u015Bci nawo\u0142uj\u0105cych do nienawi\u015Bci na tle etnicznym, rasowym, religijnym lub jakimkolwiek innym oraz propaguj\u0105cych faszyzm, nazizm, komunizm oraz inne zbrodnicze ideologie;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "w nadmierny spos\xF3b obci\u0105\u017Ca\u0107 serwera, na kt\xF3rym znajduje si\u0119 Serwis;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "dodawa\u0107 do Serwisu tre\u015Bci zawieraj\u0105cych jakiekolwiek dane osobowe lub oznaczenia umo\u017Cliwiaj\u0105ce identyfikacj\u0119 konkretnych podmiot\xF3w."
                })]
              })]
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Us\u0142ugodawca ma prawo do usuwania tre\u015Bci z\xA0Serwisu bez podania przyczyny, a\xA0w szczeg\xF3lno\u015Bci w\xA0przypadku powzi\u0119cia wiarygodnej informacji o\xA0naruszeniu prawa lub Regulaminu."
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Je\u015Bli zdaniem U\u017Cytkownika opublikowana w\xA0Serwisie tre\u015B\u0107 narusza prawo, Regulamin lub zasady wsp\xF3\u0142\u017Cycia spo\u0142ecznego, U\u017Cytkownik mo\u017Ce powiadomi\u0107 Us\u0142ugodawc\u0119 za po\u015Brednictwem poczty elektronicznej na adres e-mail: abuse@PolskiFrontend.pl."
            })]
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
          className: termsOfUse_module_default.a.li,
          children: ["Logowanie U\u017Cytkownika", /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
            className: termsOfUse_module_default.a.ol,
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "U\u017Cytkownik ma mo\u017Cliwo\u015B\u0107 zalogowania si\u0119 w\xA0Serwisie za po\u015Brednictwem GitHub."
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Logowanie jest bezp\u0142atne."
            }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
              children: ["Zalogowany U\u017Cytkownik ma mo\u017Cliwo\u015B\u0107 korzystania z\xA0nast\u0119puj\u0105cych dodatkowych funkcji Serwisu:", ' ', /*#__PURE__*/Object(jsx_runtime["jsx"])("ol", {
                children: /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "g\u0142osowanie na poszczeg\xF3lne pytania opublikowane w\xA0Serwisie."
                })
              })]
            })]
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
          className: termsOfUse_module_default.a.li,
          children: ["Odpowiedzialno\u015B\u0107 i\xA0sankcje", /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
            className: termsOfUse_module_default.a.ol,
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "U\u017Cytkownik zobowi\u0105zuje si\u0119, \u017Ce w\xA0momencie wyst\u0105pienia przez osoby trzecie z roszczeniami w\xA0stosunku do Us\u0142ugodawcy z\xA0tytu\u0142u naruszenia jakichkolwiek praw tych os\xF3b trzecich przez tre\u015Bci zamieszczone przez U\u017Cytkownika, U\u017Cytkownik ten wst\u0105pi do sprawy w\xA0miejsce Us\u0142ugodawcy oraz przejmie na siebie w\xA0ca\u0142o\u015Bci koszty ewentualnego post\u0119powania s\u0105dowego, zas\u0105dzonych odszkodowa\u0144 oraz inne."
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Naruszenie Regulaminu przez U\u017Cytkownika mo\u017Ce skutkowa\u0107 zablokowaniem mu dost\u0119pu do Serwisu, a\xA0w przypadku gdy naruszone zosta\u0142y przepisy prawa, r\xF3wnie\u017C zawiadomieniem odpowiednich organ\xF3w lub skierowaniem sprawy do s\u0105du."
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Przez naruszenie Regulaminu rozumie si\u0119 tak\u017Ce namawianie innych os\xF3b do jego naruszenia, a\xA0tak\u017Ce u\u0142atwianie jego obchodzenia, jak r\xF3wnie\u017C czerpanie korzy\u015Bci maj\u0105tkowych z\xA0tych czynno\u015Bci."
            })]
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
          className: termsOfUse_module_default.a.li,
          children: ["Wy\u0142\u0105czenie odpowiedzialno\u015Bci i\xA0zastrze\u017Cenia", /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
            className: termsOfUse_module_default.a.ol,
            children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
              children: ["W\xA0najszerszym zakresie dopuszczalnym przez prawo, wy\u0142\u0105czona zostaje odpowiedzialno\u015B\u0107 Us\u0142ugodawcy za:", ' ', /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
                children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "szkody wynikaj\u0105ce ze sposobu w\xA0jaki U\u017Cytkownicy korzystaj\u0105 z\xA0Serwisu, niew\u0142a\u015Bciwego dzia\u0142ania Serwisu, braku dost\u0119pu do Serwisu, jak r\xF3wnie\u017C szkody powsta\u0142e w\xA0wyniku dzia\u0142ania si\u0142y wy\u017Cszej;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "jakiekolwiek tre\u015Bci zamieszczone w\xA0Serwisie przez U\u017Cytkownik\xF3w."
                })]
              })]
            }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
              children: ["W\xA0najszerszym dopuszczalnym zakresie, Us\u0142ugodawca ma prawo do:", /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
                className: termsOfUse_module_default.a.ol,
                children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "zmiany parametr\xF3w oraz sposobu dzia\u0142ania Serwisu;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "wy\u0142\u0105czania Serwisu bez wcze\u015Bniejszego powiadomienia U\u017Cytkownik\xF3w;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "usuwania opublikowanych tre\u015Bci;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "ca\u0142kowitego zaprzestania \u015Bwiadczenia us\u0142ug;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "przeniesienia wszelkich praw i\xA0obowi\u0105zk\xF3w zwi\u0105zanych ze \u015Bwiadczeniem us\u0142ug drog\u0105 elektroniczn\u0105 w\xA0Serwisie na inny podmiot."
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
          className: termsOfUse_module_default.a.li,
          children: ["Informacje o\xA0zagro\u017Ceniach", /*#__PURE__*/Object(jsx_runtime["jsx"])("ol", {
            className: termsOfUse_module_default.a.ol,
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Podstawowym zagro\u017Ceniem ka\u017Cdego u\u017Cytkownika Internetu, w\xA0tym os\xF3b korzystaj\u0105cych z us\u0142ug \u015Bwiadczonych drog\u0105 elektroniczn\u0105, jest mo\u017Cliwo\u015B\u0107 zainfekowania systemu teleinformatycznego przez z\u0142o\u015Bliwe oprogramowanie tworzone g\u0142\xF3wnie w\xA0celu wyrz\u0105dzania szk\xF3d, takie jak wirusy, robaki, czy konie troja\u0144skie. Aby unikn\u0105\u0107 zagro\u017Ce\u0144 z\xA0tym zwi\u0105zanych, a\xA0w tym pojawiaj\u0105cych si\u0119 w\xA0momencie otwierania wiadomo\u015Bci e-mail, nale\u017Cy wyposa\u017Cy\u0107 swoje urz\u0105dzenia dost\u0119powe w\xA0programy antywirusowe i\xA0pami\u0119ta\u0107 o\xA0ich bie\u017C\u0105cej aktualizacji do najnowszych wersji. Korzystanie z\xA0us\u0142ug \u015Bwiadczonych przez Internet wi\u0105\u017Ce si\u0119 z\xA0mo\u017Cliw\u0105 dzia\u0142alno\u015Bci\u0105 hacker\xF3w, zmierzaj\u0105cych do w\u0142amania si\u0119 zar\xF3wno do Serwisu (np. ataki na witryn\u0119 lub serwer), jak i\xA0do systemu U\u017Cytkownika. Warto pami\u0119ta\u0107, \u017Ce mimo stosowania przez Us\u0142ugodawc\u0119 r\xF3\u017Cnorodnych, nowoczesnych technologii obronnych, nie istnieje w 100% skuteczne zabezpieczenie przed opisanymi wy\u017Cej niepo\u017C\u0105danymi dzia\u0142aniami. Wi\u0119cej na temat stosowanych przez Us\u0142ugodawc\u0119 zasad ochrony danych znale\u017A\u0107 mo\u017Cna w Polityce prywatno\u015Bci."
            })
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
          className: termsOfUse_module_default.a.li,
          children: ["Ochrona danych osobowych", /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
            className: termsOfUse_module_default.a.ol,
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Administratorem danych osobowych U\u017Cytkownik\xF3w, jest Micha\u0142 Miszczyszyn prowadz\u0105cy dzia\u0142alno\u015B\u0107 gospodarcz\u0105 pod firm\u0105 \u201EType of Web - Micha\u0142 Miszczyszyn\u201D, zarejestrowan\u0105 w\xA0Centralnej Ewidencji i\xA0Informacji o\xA0Dzia\u0142alno\u015Bci Gospodarczej pod adresem ul. Ba\u017Cantowa 9/21, 80-175 Gda\u0144sk, NIP: 6040080451 (zwany dalej \u201EAdministratorem\u201D). Adres do korespondencji: ul. Ba\u017Cantowa 9/21, 80-175 Gda\u0144sk; adres e-mail: hi@typeofweb.com"
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Korzystanie z\xA0Serwisu wi\u0105\u017Ce si\u0119 z\xA0przetwarzaniem danych osobowych U\u017Cytkownik\xF3w w celu logowania U\u017Cytkownika - na podstawie art. 6 ust. 1 RODO, czyli zgody U\u017Cytkownika, przetwarzane s\u0105 adres e-mail, imi\u0119 i\xA0nazwisko oraz ewentualnie nazwa u\u017Cytkownika."
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Dane osobowe nie s\u0105 przetwarzane w\xA0celu zautomatyzowanego podejmowania decyzji bez wyra\u017Anej zgody U\u017Cytkownik\xF3w."
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Dane osobowe nie s\u0105 przekazywane podmiotom trzecim i\xA0s\u0105 przechowywane przez czas posiadania konta U\u017Cytkownika. W\xA0przypadku opublikowania komentarza przez zalogowanego U\u017Cytkownika, jego nazwa b\u0119dzie widoczna dla wszystkich odwiedzaj\u0105cych Serwis. Dane osobowe zgromadzone w\xA0zwi\u0105zku z\xA0zamieszczeniem komentarza b\u0119d\u0105 przechowywane przez czas wy\u015Bwietlania tego komentarza, chyba \u017Ce wcze\u015Bniej U\u017Cytkownik poprosi o\xA0usuni\u0119cie komentarza."
            }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
              children: ["Zgodnie z\xA0RODO, U\u017Cytkownik ma nast\u0119puj\u0105ce prawa w\xA0zwi\u0105zku z\xA0przetwarzaniem jego danych osobowych:", /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
                className: termsOfUse_module_default.a.ol,
                children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "Prawo do informacji, w\xA0jaki spos\xF3b dane osobowe s\u0105 przetwarzane;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "Prawo do dost\u0119pu i\xA0sprostowania danych osobowych;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "Prawo do usuni\u0119cia danych osobowych; Administrator mo\u017Ce odm\xF3wi\u0107 usuni\u0119cia danych, co do kt\xF3rych ma podstaw\u0119 do ich dalszego przetwarzania (np. realizacja obowi\u0105zku prawnego lub dochodzenia roszcze\u0144 lub obrony przed roszczeniami, kt\xF3re mog\u0105 by\u0107 kierowane przeciwko Administratorowi);"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "Prawo do \u017C\u0105dania ograniczenia przetwarzania danych osobowych;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "Prawo do zg\u0142oszenia sprzeciwu co do przetwarzania danych osobowych, je\u017Celi podstaw\u0105 przetwarzania jest uzasadniony interes Administratora lub wykonywanie zada\u0144 w\xA0interesie publicznym;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "Prawo do cofni\u0119cia zgody, je\u017Celi dane osobowe by\u0142y przetwarzane na podstawie zgody u\u017Cytkownika;"
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
                  children: "Prawo do przeniesienia danych osobowych."
                })]
              })]
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Wszystkie powy\u017Csze prawa mo\u017Cna zrealizowa\u0107 kontaktuj\u0105c si\u0119 z\xA0Administratorem drog\u0105 elektroniczn\u0105 pod adresem: hi@typeofweb.com. Zg\u0142oszone \u017C\u0105dania b\u0119d\u0105 realizowane bez zb\u0119dnej zw\u0142oki, nie p\xF3\u017Aniej ni\u017C w\xA0terminie 30 dni od dnia otrzymania \u017C\u0105dania. W\xA0tym terminie Administrator udzieli odpowiedzi lub poinformuje o\xA0ewentualnym wyd\u0142u\u017Ceniu terminu i\xA0wyja\u015Bni przyczyny. Je\u017Celi Administrator powe\u017Amie w\u0105tpliwo\u015Bci co do tego, czy okre\u015Blone \u017C\u0105danie zosta\u0142o zg\u0142oszone przez osob\u0119 uprawnion\u0105, mo\u017Ce on zada\u0107 kilka dodatkowych pyta\u0144 w\xA0celu weryfikacji to\u017Csamo\u015Bci zg\u0142aszaj\u0105cego."
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Administrator gwarantuje poufno\u015B\u0107 wszelkich przekazanych mu danych osobowych. Administrator zapewnia podj\u0119cie wszelkich \u015Brodk\xF3w bezpiecze\u0144stwa i\xA0ochrony danych osobowych wymaganych przez przepisy prawa. Dane osobowe s\u0105 gromadzone z\xA0nale\u017Cyt\u0105 staranno\u015Bci\u0105 i\xA0odpowiednio chronione przed dost\u0119pem do nich przez osoby do tego nieupowa\u017Cnione."
            }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
              children: ["Je\u015Bli uwa\u017Casz, \u017Ce Administrator przetwarza dane osobowe niezgodnie z\xA0prawem, mo\u017Cesz wnie\u015B\u0107 skarg\u0119 do w\u0142a\u015Bciwego organu, kt\xF3rym jest Prezes Urz\u0119du Ochrony Danych Osobowych.", ' ']
            })]
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
          className: termsOfUse_module_default.a.li,
          children: ["Postanowienia ko\u0144cowe", ' ', /*#__PURE__*/Object(jsx_runtime["jsxs"])("ol", {
            className: termsOfUse_module_default.a.ol,
            children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("li", {
              children: ["Us\u0142ugodawca zastrzega sobie prawo do zmiany Regulaminu. O\xA0tre\u015Bci zmian Regulaminu Us\u0142ugodawca poinformuje U\u017Cytkownik\xF3w przez umieszczenie na stronie internetowej https://PolskiFrontend.pl/regulamin wiadomo\u015Bci o\xA0zmianie Regulaminu, zawieraj\u0105cej zestawienie zmian Regulaminu i\xA0utrzymanie tej informacji przez okres co najmniej 14 kolejnych dni kalendarzowych.", ' ']
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Zmiany Regulaminu wchodz\u0105 w\xA0\u017Cycie w\xA0terminie podanym wraz z\xA0informacj\u0105 o\xA0jego zmianie, nie wcze\u015Bniej jednak ni\u017C po up\u0142ywie 14 dni kalendarzowych od momentu poinformowania o\xA0zmianach Regulaminu, z\xA0tym zastrze\u017Ceniem, \u017Ce zmieniony Regulamin b\u0119dzie wi\u0105za\u0107 U\u017Cytkownika, o\xA0ile nie zaprzestanie on korzystania z\xA0Serwisu."
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
              children: "Regulamin dost\u0119pny jest nieodp\u0142atnie pod adresem https://PolskiFrontend.pl/regulamin w formie, kt\xF3ra umo\u017Cliwia pozyskanie, odtwarzanie i\xA0utrwalanie tre\u015Bci Regulaminu za pomoc\u0105 systemu teleinformatycznego, kt\xF3rym pos\u0142uguje si\u0119 U\u017Cytkownik. Pod tym samym adresem dost\u0119pne s\u0105 wszystkie archiwalne wersje Regulaminu wraz z\xA0informacj\u0105 o ramach czasowych ich obowi\u0105zywania."
            })]
          })]
        })]
      })]
    })]
  });
};
TermsOfUse_TermsOfUse.displayName = 'TermsOfUse';
// CONCATENATED MODULE: ./pages/regulamin/index.tsx




function TermsOfUsePage() {
  return /*#__PURE__*/Object(jsx_runtime["jsx"])(Layout["a" /* Layout */], {
    title: "Regulamin serwisu",
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])(TermsOfUse_TermsOfUse, {})
  });
}

/***/ }),

/***/ "wujS":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regulamin",
      function () {
        return __webpack_require__("v/pb");
      }
    ]);
  

/***/ })

},[["wujS",1,0,2,4,3,5,6]]]);